import Vue from 'vue'
import App from './App.vue'

//router
import VueRouter from 'vue-router'

//Meta
import Meta from 'vue-meta';

import axios from 'axios'
import VueAxios from 'vue-axios'
import ReadMore from 'vue-read-more';

//icons 
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInstagram, faLinkedin, faFacebookSquare, faTwitterSquare } from '@fortawesome/free-brands-svg-icons';
import { faSearch} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSimpleAlert from "vue-simple-alert";

import VueLazyload from 'vue-lazyload'


library.add(faInstagram, faLinkedin, faFacebookSquare, faTwitterSquare, faSearch)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(VueSimpleAlert);
Vue.use(VueRouter);
Vue.use(Meta);
Vue.use(ReadMore);
Vue.use(VueAxios, axios)

Vue.use(VueLazyload)

function lazyLoad(view){
  return() => import(`@/views/${view}.vue`)
}

Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: 'images/loading.gif',
  attempt: 1
})

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: lazyLoad('Home') },
    { path: '/about', component: lazyLoad('About') },
    { path: '/work', component: lazyLoad('Cases') },
    { path: '/services-agreement', component: lazyLoad('Terms')},
    { path: '/privacy-policy', component: lazyLoad('Privacy')},
    { path: '/case/:slug', component: lazyLoad('Case')},
    { path: "*", component: lazyLoad('PageNotFound') },
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
